.ugc-review-dt-all-images-modal-wrap {
  width: 100%;
  max-height: 80vh;
  min-height: 25vh;
  overflow-y: auto;

  .ugc-customer-images-list {
    .ugc-review-image {
      width: 144px;
      height: 144px;
      border-radius: 4px;
      overflow: hidden;
      & > img {
        width: 100%;
        height: auto;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .pagination {
    margin: 0 auto;
    .pagination-number-wrap {
      margin: 0 20px;
      p {
        &:last-child {
          margin-right: 0;
          margin-left: 0;
        }
        &.active,
        &:hover {
          color: var(--green-dark);
          border-bottom: 2px solid var(--green-dark);
        }
      }
    }
  }
}

@media screen and (max-width: 1050px) {
  .ugc-review-dt-all-images-modal {
    .modal-dialog-root {
      width: 600px !important;
    }
    .ugc-review-dt-all-images-modal-wrap {
      .ugc-customer-images-list {
        .ugc-review-image {
          width: 104px;
          height: 104px;
        }
      }
    }
  }
}
